import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Inspeksi() {
  const [garduList, setGarduList] = useState([]);
  const [selectedGI, setSelectedGI] = useState('');
  const [activeTab, setActiveTab] = useState('apar');
  const [riwayat, setRiwayat] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [detailData, setDetailData] = useState(null);
  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [bulan, setBulan] = useState(new Date().getMonth() + 1);
  const [tahun, setTahun] = useState(new Date().getFullYear());

  useEffect(() => { loadGarduList(); }, []);
  useEffect(() => { if (selectedGI) loadRiwayat(); }, [selectedGI, activeTab, bulan, tahun]);

  const loadGarduList = async () => {
    try {
      const res = await api.get('/gardu');
      setGarduList(res.data.data || []);
      if (res.data.data?.length > 0) setSelectedGI(res.data.data[0].id);
    } catch (err) { console.error(err); }
  };

  const loadRiwayat = async () => {
    setIsLoading(true);
    setSelectedDetail(null);
    setDetailData(null);
    try {
      const res = await api.get(`/${activeTab}/riwayat/${selectedGI}?bulan=${bulan}&tahun=${tahun}`);
      setRiwayat(res.data.data || []);
    } catch (err) { console.error(err); setRiwayat([]); }
    setIsLoading(false);
  };

  const loadDetail = async (item) => {
    setSelectedDetail(item);
    setIsLoadingDetail(true);
    try {
      const res = await api.get(`/${activeTab}/detail/${item.id}`);
      setDetailData(res.data.data);
    } catch (err) { console.error(err); setDetailData(null); }
    setIsLoadingDetail(false);
  };

  const bulanList = ['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'];
  const formatTanggal = (tgl) => {
    try {
      return new Date(tgl).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' });
    } catch { return tgl; }
  };

  const getNilai = (item) => {
    if (activeTab === 'apar') return parseFloat(item.nilai_apar || 0).toFixed(1);
    if (activeTab === 'p3k') return parseFloat(item.nilai_p3k || 0).toFixed(1);
    return parseFloat(item.nilai_apd || 0).toFixed(1);
  };

  const getColor = (nilai) => {
    const n = parseFloat(nilai);
    if (n >= 80) return 'text-green-600';
    if (n >= 60) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getBgColor = (nilai) => {
    const n = parseFloat(nilai);
    if (n >= 80) return 'bg-green-50 border-green-200';
    if (n >= 60) return 'bg-yellow-50 border-yellow-200';
    return 'bg-red-50 border-red-200';
  };

  const renderDetailApar = (data) => (
    <div>
      {(data.detail || []).map((unit, i) => {
        const items = [
          { label: 'Nomor Sesuai', key: 'nomor_sesuai' },
          { label: 'Penempatan Benar', key: 'penempatan_benar' },
          { label: 'Mudah Dicapai', key: 'mudah_dicapai' },
          { label: 'Peralatan Bersih', key: 'peralatan_bersih' },
          { label: 'Data Kelas Kebakaran', key: 'data_kelas_kebakaran' },
          { label: 'Data Media Pemadam', key: 'data_media_pemadam' },
          { label: 'Petunjuk Penggunaan', key: 'petunjuk_penggunaan' },
          { label: 'Data Nomor Peralatan', key: 'data_nomor_peralatan' },
          { label: 'Berat Cukup', key: 'berat_cukup' },
          { label: 'Tali Seal Pengaman', key: 'tali_seal_pengaman' },
          { label: 'Pin Pengaman', key: 'pin_pengaman' },
          { label: 'Jarum Tekanan Normal', key: 'jarum_tekanan_normal' },
          { label: 'Corong Bersih', key: 'corong_bersih' },
        ];
        const adaMasalah = items.some(item => unit[item.key] === false);
        return (
          <div key={i} className={`mb-4 rounded-lg border p-3 ${adaMasalah ? 'border-red-200 bg-red-50' : 'border-green-200 bg-green-50'}`}>
            <div className="flex justify-between items-center mb-2">
              <div>
                <p className="font-bold text-sm">{unit.kode_apar}</p>
                <p className="text-xs text-gray-500">{unit.jenis_isi} {unit.berat} • {unit.lokasi_penempatan}</p>
              </div>
              <span className={`font-bold ${adaMasalah ? 'text-red-600' : 'text-green-600'}`}>
                {parseFloat(unit.nilai_unit || 0).toFixed(0)}%
              </span>
            </div>
            <div className="grid grid-cols-2 gap-1">
              {items.filter(item => unit[item.key] !== null).map((item, j) => (
                <div key={j} className="flex items-center gap-1 text-xs">
                  <span>{unit[item.key] === true ? '✅' : '❌'}</span>
                  <span className={unit[item.key] === false ? 'text-red-600 font-medium' : 'text-gray-600'}>{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );

  const renderDetailP3k = (data) => (
    <table className="w-full text-sm">
      <thead className="bg-gray-50">
        <tr>
          <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">Item P3K</th>
          <th className="px-3 py-2 text-center text-xs font-medium text-gray-500">Standar</th>
          <th className="px-3 py-2 text-center text-xs font-medium text-gray-500">Aktual</th>
          <th className="px-3 py-2 text-center text-xs font-medium text-gray-500">Status</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {(data.detail || []).map((item, i) => {
          const isOk = parseInt(item.jumlah_aktual) >= parseInt(item.jumlah_standar);
          return (
            <tr key={i} className={isOk ? '' : 'bg-red-50'}>
              <td className="px-3 py-2 text-gray-800">{item.nama_item}</td>
              <td className="px-3 py-2 text-center font-medium">{item.jumlah_standar}</td>
              <td className={`px-3 py-2 text-center font-bold ${isOk ? 'text-green-600' : 'text-red-600'}`}>{item.jumlah_aktual}</td>
              <td className="px-3 py-2 text-center">{isOk ? '✅' : '❌'}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  const renderDetailApd = (data) => (
    <table className="w-full text-sm">
      <thead className="bg-gray-50">
        <tr>
          <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">Item APD</th>
          <th className="px-3 py-2 text-center text-xs font-medium text-gray-500">Standar</th>
          <th className="px-3 py-2 text-center text-xs font-medium text-gray-500">Aktual</th>
          <th className="px-3 py-2 text-center text-xs font-medium text-gray-500">Kondisi</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {(data.detail || []).map((item, i) => {
          const kondisiColor = item.kondisi === 'AB' ? 'bg-green-100 text-green-700' : item.kondisi === 'ATB' ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700';
          const isOk = parseInt(item.jumlah_aktual) >= parseInt(item.jumlah_standar);
          return (
            <tr key={i} className={item.kondisi !== 'AB' ? 'bg-orange-50' : ''}>
              <td className="px-3 py-2 text-gray-800">{item.nama_item}</td>
              <td className="px-3 py-2 text-center font-medium">{item.jumlah_standar}</td>
              <td className={`px-3 py-2 text-center font-bold ${isOk ? 'text-green-600' : 'text-red-600'}`}>{item.jumlah_aktual}</td>
              <td className="px-3 py-2 text-center">
                <span className={`px-2 py-0.5 rounded text-xs font-bold ${kondisiColor}`}>{item.kondisi}</span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return (
    <div className="p-4 h-screen flex flex-col overflow-hidden">
      <div className="flex justify-between items-center mb-3 bg-green-50 rounded-xl px-5 py-3 border border-green-100">
        <div>
          <h1 className="text-xl font-bold text-gray-800">Riwayat Inspeksi</h1>
          <p className="text-gray-500 text-xs mt-0.5">Lihat histori inspeksi per Gardu Induk</p>
        </div>
      </div>

      <div className="bg-white rounded-xl p-3 shadow-sm border border-gray-100 mb-3">
        <div className="flex flex-wrap gap-3 items-end">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Gardu Induk</label>
            <select value={selectedGI} onChange={(e) => setSelectedGI(e.target.value)}
              className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
              {garduList.map(gi => <option key={gi.id} value={gi.id}>{gi.nama}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Bulan</label>
            <select value={bulan} onChange={(e) => setBulan(parseInt(e.target.value))}
              className="px-3 py-1.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm">
              {bulanList.map((b, i) => <option key={i+1} value={i+1}>{b}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Tahun</label>
            <select value={tahun} onChange={(e) => setTahun(parseInt(e.target.value))}
              className="px-3 py-1.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm">
              {[2025, 2026, 2027].map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <div className="flex gap-2">
            {['apar', 'p3k', 'apd'].map(tab => (
              <button key={tab} onClick={() => setActiveTab(tab)}
                className={`px-4 py-1.5 rounded-lg font-medium text-sm transition-colors ${
                  activeTab === tab ? 'bg-green-700 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}>
                {tab.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="flex gap-4 flex-1 min-h-0">
        <div className="w-1/3 h-full">
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 h-full flex flex-col">
            <div className="p-3 border-b border-gray-100">
              <h2 className="font-bold text-gray-800 text-sm">Riwayat {activeTab.toUpperCase()}</h2>
            </div>
            {isLoading ? (
              <div className="flex justify-center p-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
              </div>
            ) : riwayat.length === 0 ? (
              <div className="text-center py-8 text-gray-400">
                <p className="text-3xl mb-2">📋</p>
                <p className="text-sm">Belum ada riwayat</p>
              </div>
            ) : (
              <div className="divide-y divide-gray-100 overflow-y-auto flex-1 min-h-0">
                {riwayat.map((item, index) => (
                  <div key={index} onClick={() => loadDetail(item)}
                    className={`p-3 cursor-pointer hover:bg-gray-50 transition-colors ${selectedDetail?.id === item.id ? 'bg-green-50 border-l-4 border-green-600' : ''}`}>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="font-medium text-gray-800 text-xs">{formatTanggal(item.tanggal_inspeksi)}</p>
                        <p className="text-[10px] text-gray-500 mt-0.5">{item.petugas}</p>
                        {activeTab === 'p3k' && <p className="text-[10px] text-gray-500">Periode {item.periode}</p>}
                      </div>
                      <span className={`font-bold text-sm ${getColor(getNilai(item))}`}>
                        {getNilai(item)}%
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="w-2/3 h-full">
          {!selectedDetail ? (
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 flex items-center justify-center h-full">
              <div className="text-center text-gray-400">
                <p className="text-4xl mb-2">👈</p>
                <p>Pilih riwayat untuk lihat detail</p>
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 h-full flex flex-col">
              <div className={`p-3 rounded-t-xl border ${getBgColor(getNilai(selectedDetail))}`}>
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-bold text-gray-800 text-sm">Detail Inspeksi {activeTab.toUpperCase()}</p>
                    <p className="text-xs text-gray-600">{formatTanggal(selectedDetail.tanggal_inspeksi)} • {selectedDetail.petugas}</p>
                    {activeTab === 'p3k' && <p className="text-xs text-gray-600">Periode {selectedDetail.periode}</p>}
                  </div>
                  <span className={`text-2xl font-bold ${getColor(getNilai(selectedDetail))}`}>
                    {getNilai(selectedDetail)}%
                  </span>
                </div>
              </div>
              <div className="relative flex-1 min-h-0">
                <div className={`p-4 h-full overflow-y-auto transition-opacity duration-200 ${isLoadingDetail ? 'opacity-40' : 'opacity-100'}`}>
                  {activeTab === 'apar' && detailData && renderDetailApar(detailData)}
                  {activeTab === 'p3k' && detailData && renderDetailP3k(detailData)}
                  {activeTab === 'apd' && detailData && renderDetailApd(detailData)}
                </div>
                {isLoadingDetail && (
                  <div className="absolute top-2 right-2">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-green-600"></div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
